import { Rocket, TrendingUp, Users, GraduationCap } from "../../../Atoms/Icons";

const whyJoin = [
  { icon: Rocket, title: "Real Impact", body: "Your work directly accelerates India's shift to electric mobility." },
  { icon: TrendingUp, title: "Fast Growth", body: "Join early and grow alongside a scaling product and team." },
  { icon: Users, title: "Collaborative Culture", body: "Flat structure, open communication, and ownership from day one." },
  { icon: GraduationCap, title: "Learning-First", body: "Hands-on exposure to hardware, IoT, and cloud in one product." },
];

export default function WhyJoin() {
  return (
    <section className="py-10 lg:py-12">
      <div className="containers-min mx-auto px-4 py-8">
        <div className="text-center mb-10">
          {/* <p className="section-eyebrow mb-2">Why Join Us</p> */}
          <h3 className="font-gilroy mb-3">Why Join Us</h3>
          <p className=" mt-3 first-letter:md:mt-5 lg:mt-7 max-w-5xl leading-normal sm:leading-9 font-poppins mx-auto">
            Electric mobility is evolving fast, and we’re building the technology to keep it moving. At VerdeMobility, you’ll have the opportunity to work on real infrastructure challenges, build impactful solutions, and be part of a team shaping how India charges, connects, and moves.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {whyJoin.map(({ icon: Icon, title, body }) => (
            <div className="info-card text-center" key={title}>
              <div className="icon-chip mx-auto"><Icon size={28} /></div>
              <h3 className="text-2xl font-bold font-gilroy mb-2 ">{title}</h3>
              {/* <p className="text-[var(--vm-text-gray)] mb-0">{body}</p> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
